import type { CmtsApiError, CmtsApiErrorContext, CmtsSafeLogEvent } from "./cmtsApiErrorTypes.js";
import { normalizeCmtsApiError } from "./cmtsApiErrorNormalizer.js";

const SENSITIVE_LOGGING_SUPPRESSIONS = [
  "access token",
  "refresh token",
  "file blob",
  "payload",
  "stack",
] as const;


export function toSafeErrorLogEvent(error: CmtsApiError, context?: CmtsApiErrorContext | undefined): CmtsSafeLogEvent {
  return {
    code: error.code,
    ...(error.httpStatus !== undefined ? { httpStatus: error.httpStatus } : {}),
    ...(context?.route ? { route: sanitize(context.route) } : {}),
    ...(context?.operation ? { operation: sanitize(context.operation) } : {}),
    ...(error.entityType ? { entityType: sanitize(error.entityType) } : {}),
    ...(error.entityId ? { entityId: sanitize(error.entityId) } : {}),
    ...(error.correlationId ? { correlationId: sanitize(error.correlationId) } : {}),
    category: error.category,
    retryable: error.retryable,
    ...(error.safeDiagnostics ? { safeDiagnostics: error.safeDiagnostics } : {}),
  };
}

export function logCmtsSafeError(error: unknown, context?: CmtsApiErrorContext | undefined): CmtsApiError {
  void SENSITIVE_LOGGING_SUPPRESSIONS;
  const normalized = normalizeCmtsApiError(error, context);
  if (normalized.code === "request_aborted") return normalized;
  const event = toSafeErrorLogEvent(normalized, context);
  if (typeof globalThis.dispatchEvent === "function" && typeof CustomEvent !== "undefined") {
    globalThis.dispatchEvent(new CustomEvent("cmts:safe-error", { detail: event }));
  }
  return normalized;
}

export function sanitize(value: string): string {
  return value
    .replace(/Bearer\s+[A-Za-z0-9._~+/=-]+/gi, "Bearer [redacted]")
    .replace(/(access_token|refresh_token|token|authorization)=([^&\s]+)/gi, "$1=[redacted]")
    .slice(0, 500);
}
